import { FC } from 'react';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dl, Dt, Dd } from '@/components/ui/DefinitionList';
import { dateFormat, displayFormat, fullNameFormat } from '@/components/utils/formatter';
import { Employee } from '../../query';

interface EmployeeInfoProps {
  employee: Employee;
}

export const EmployeeInfo: FC<EmployeeInfoProps> = ({ employee }) => {
  return (
    <Panel>
      <Headding>基本情報</Headding>
      <Item>
        <Grid col2>
          <Dl>
            <Dt>スタッフコード</Dt>
            <Dd>{displayFormat(employee.staffCode)}</Dd>
          </Dl>
          <Dl>
            <Dt>名前</Dt>
            <Dd>{fullNameFormat(employee.lastName, employee.firstName)}</Dd>
          </Dl>
          <Dl>
            <Dt>雇用形態</Dt>
            <Dd>{displayFormat(employee.employmentType)}</Dd>
          </Dl>
          <Dl>
            <Dt>グループ</Dt>
            <Dd>
              {employee.groups?.length
                ? employee.groups.map(group => (
                    <span key={group}>
                      {displayFormat(group)}
                      <br />
                    </span>
                  ))
                : displayFormat()}
            </Dd>
          </Dl>
          <Dl>
            <Dt>役職</Dt>
            <Dd>{displayFormat(employee.position)}</Dd>
          </Dl>
          <Dl>
            <Dt>入社日</Dt>
            <Dd>{dateFormat(employee.joinedAt, 'seireki')}</Dd>
          </Dl>
          <Dl>
            <Dt>退職日</Dt>
            <Dd>{dateFormat(employee.retiredAt, 'seireki')}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
